import moment from 'moment'

const formatDate = (date) => {
    const months = {
        '01': 'Janeiro',
        '02': 'Fevereiro',
        '03': 'Março',
        '04': 'Abril',
        '05': 'Maio',
        '06': 'Junho',
        '07': 'Julho',
        '08': 'Agosto',
        '09': 'Setembro',
        '10': 'Outubro',
        '11': 'Novembro',
        '12': 'Dezembro',
    }

    const daysOfWeek = {
        'Sunday': 'Domingo',
        'Monday': 'Segunda-feira',
        'Tuesday': 'Terça-feira',
        'Wednesday': 'Quarta-feira',
        'Thursday': 'Quinta-feira',
        'Friday': 'Sexta-feira',
        'Saturday': 'Sábado'
    }
    const weekDay = moment(date, 'MM-DD-YYYY',).format('dddd')
    const day = moment(date, 'MM-DD-YYYY',).format('DD')
    const month = moment(date, 'MM-DD-YYYY',).format('MM')
    const year = moment(date, 'MM-DD-YYYY',).format('YYYY')
    return `${daysOfWeek[weekDay]}, ${day} de ${months[month]} de ${year}`
}

export default formatDate